import React from "react";

export default function EndDay() {
  return null;
}